<template>
	<v-content :style="{'background-image': `url('`+ require('../assets/bg-login.jpg') +`')`}"
	           style="background-size: cover">
		<!-- Header -->
		<Header></Header>

		<!-- Menu -->
		<v-layout justify-center>
			<v-flex xs12 style="background-color: #527281">
				<v-container>
					<v-layout>
						<v-flex md3 style="text-align: left;">
							<v-btn text small style="color: white;font-size: 18px" @click="$router.push('/home').catch(err => {})">
								หน้าแรก
							</v-btn>
						</v-flex>
					</v-layout>
				</v-container>
			</v-flex>
		</v-layout>

		<!-- Form Search -->
		<v-container>
			<v-layout justify-center>
				<v-flex class="mt-2" style="font-size: 56px; font-weight: bold;color: #D97C57;">
					ค้นหา
				</v-flex>
			</v-layout>
			<v-layout justify-center>
				<v-flex style="font-size: 28px; font-weight: bold;color: #D97C57;">
					คุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์
				</v-flex>
			</v-layout>
			<v-layout justify-center>
				<v-flex xs12 sm10 md12 class="mb-6 mt-6">
					<v-card class="py-12" style="border-radius: 25px;background: white; box-shadow: #2c3e50">
						<v-layout justify-center>
							<v-flex xs12 class="px-2" style="font-size: 24px">
								<div class="form-search">
									<v-form>
										<v-layout justify-center>
											<v-flex v-if="$vuetify.breakpoint.smAndUp" shrink ml-7 class="d-flex mt-1">
												<v-layout column style="font-size: 18px">
													<v-flex class="mr-4" style="text-align: right">
														ชื่อไทย:
													</v-flex>
													<v-flex class="mr-4" style="text-align: right">
														ชื่ออังกฤษ :
													</v-flex>
													<v-flex class="mr-4" style="text-align: right">
														กลุ่มหลักสิ่งอุปกรณ์ :
													</v-flex>
													<v-flex class="mr-4" style="text-align: right">
														อุปกรณ์กลุ่มย่อยของอุปกรณ์ :
													</v-flex>
													<v-flex class="mr-4" style="text-align: right">
														เลขที่สิ่งอุปกรณ์ :
													</v-flex>
													<v-flex class="mr-4" style="text-align: right">
														ปีที่จัดทำ :
													</v-flex>
												</v-layout>
											</v-flex>

											<v-flex md5>
												<v-layout column>
													<v-flex>
														<v-text-field
															:label="$vuetify.breakpoint.smAndDown ? 'ชื่อไทย':''"
															background-color="#E5E5E5"
															v-model="medSearch.name_th"
															item-color="#84A2A8"
															solo
															required>
														</v-text-field>
													</v-flex>
													<v-flex>
														<v-text-field
															:label="$vuetify.breakpoint.smAndDown ? 'ชื่ออังกฤษ':''"
															background-color="#E5E5E5"
															item-color="#84A2A8"
															v-model="medSearch.name_en"
															solo
															required>
														</v-text-field>
													</v-flex>
													<v-flex>
														<multiselect
															:options="medGroups"
															v-model="medSearch.main_group"
															placeholder="กลุ่มหลักสิ่งอุปกรณ์"
															label="main_group_desc"
															track-by="group_main"
															@input="onSelectMedGroup"
														></multiselect>
<!--														<v-select-->
<!--																:options="medGroups"-->
<!--																v-model="medSearch.main_group"-->
<!--																placeholder="กลุ่มหลักสิ่งอุปกรณ์"-->
<!--																label="main_group_desc"-->
<!--																track-by="group_main"-->
<!--																@select="onSelectMedGroup"-->
<!--														></v-select>-->
													</v-flex>
													<v-flex>
														<multiselect
															:options="medSubGroups"
															v-model="medSearch.sub_group"
															placeholder="อุปกรณ์กลุ่มย่อยของอุปกรณ์"
															label="sub_group1_desc"
															track-by="sub_group1">
														</multiselect>
													</v-flex>
													<v-flex>
														<v-text-field
															:label="$vuetify.breakpoint.smAndDown ? 'เลขที่สิ่งอุปกรณ์':''"
															min="0"
															type="number"
															background-color="#E5E5E5"
															item-color="#84A2A8"
															v-model="medSearch.spec_no"
															solo
															required>
														</v-text-field>
													</v-flex>
													<v-flex>
														<v-text-field
															:label="$vuetify.breakpoint.smAndDown ? 'ปีที่จัดทำ':''"
															min="0"
															item-color="#84A2A8"
															type="number"
															background-color="#E5E5E5"
															v-model="medSearch.year"
															solo
															required>
														</v-text-field>
													</v-flex>
												</v-layout>
											</v-flex>
										</v-layout>
									</v-form>
								</div>
							</v-flex>
						</v-layout>
					</v-card>
				</v-flex>
			</v-layout>
			<v-layout class="form-search mb-12" justify-center>
				<v-flex mx-3 style="text-align: right">
					<v-btn
						style="background-color: #527281; color: white;border-radius: 25px;width: 150px;font-size: 18px"
						@click="search()">
						<span>ค้นหา</span>
					</v-btn>
				</v-flex>
				<v-flex mx-3 style="text-align: left">
					<v-btn
						style="background-color: #BDBDBD; color: white;border-radius: 25px;width: 150px;font-size: 18px"
						@click="clear()">
						<span>ล้างการค้นหา</span>
					</v-btn>
				</v-flex>
			</v-layout>
		</v-container>

		<!-- Table Form -->
		<v-layout style="background-color: white;" v-if="showTable">
			<v-flex class="mt-4">
				<v-layout>
					<v-flex class="ml-12" style="text-align: left; font-size: 32px;">
						ผลการค้นหา : {{ meds.total }} รายการ
					</v-flex>
				</v-layout>
				<v-layout justify-center class="table-search">
					<v-flex shrink xs10 md12 class="mx-12 my-2 mb-12">
						<v-card>
							<template>
<!--								:items="meds"-->
								<v-data-table
									:mobile-breakpoint="600"
									:headers="headers"
									:items="meds.data"
									:hide-default-footer="true"
								>
									<template v-slot:item.name_th="{ item }">
										<v-flex ml-4 style="text-align: left;">
											{{item.name_th}}
										</v-flex>
									</template>
									<template v-slot:item.name_en="{ item }">
										<v-flex ml-4 style="text-align: left;">
											{{item.name_en}}
										</v-flex>
									</template>
									<template v-slot:item.showData="{ item }">
										<router-link
												:to="{ name: 'show-detail', query: { id: item.id }}"
												target="_blank"
												style="text-decoration: none"
										>
											<v-icon style="color: #D97C57">search</v-icon>
										</router-link>
									</template>
									<!-- สั่งพิมพ์เพื่อจัดหา -->
									<template v-slot:item.printBuyPDF="{ item }">
										<v-icon style="color: #D97C57;cursor: pointer" @click="getOrder(item.id)">attach_file</v-icon>
									</template>
									<!-- สั่งพิมพ์เพื่อดู -->
									<template v-slot:item.printViewPDF="{ item }">
										<v-icon style="color: #D97C57;cursor: pointer" @click="viewOrder(item.id)">attach_file</v-icon>
									</template>
								</v-data-table>
							</template>
						</v-card>
					</v-flex>
				</v-layout>
				<v-layout>
					<v-flex>
						<v-pagination
								:length="pagination.last_page"
								:total-visible="9"
								v-model="pagination.current_page"
								@input="getPagination"
						></v-pagination>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout>
			<v-flex class="py-6" style="background-color: white">
			</v-flex>
		</v-layout>

		<!--Test Generate PDF-->
		<v-layout>
            <v-flex>
                <v-btn @click="getPDF()">
                    Generate PDF
                </v-btn>
            </v-flex>
		</v-layout>

		<!-- Footer -->
		<Footer></Footer>
	</v-content>
</template>

<script>
  import Header from "../components/Header"
  import Footer from "../components/Footer"
  import { mapState, mapActions } from "vuex";
  import Login from "./Login";

  export default {
    	name: "HomeSearch",

		components: {
		  Footer,
		  Header
		},

		data: () => ({
		  showTable: false,
		  headers: [
			{text: 'เลขที่ สป.', value: 'spec_no', sortable: true, align: 'center', width: "1%"},
			{text: 'หมายเลข สป.', value: 'spec_code', sortable: true, align: 'center', width: "1%"},
			{text: 'ชื่อ สป. (ไทย)', value: 'name_th', sortable: true, align: 'center', width: "10%"},
			{text: 'ชื่อ สป. (อังกฤษ)', value: 'name_en', sortable: true, align: 'center', width: "10%"},
			{text: 'อุปกรณ์กลุ่มย่อยของอุปกรณ์', value: 'group_num', sortable: true, align: 'center', width: "1%"},
			{text: 'ปีที่จัดทำ', value: 'year', sortable: true, align: 'center', width: "1%"},
			{text: 'ประเภท', value: 'type_spec', sortable: true, align: 'center', width: "1%"},
			{text: 'GPSC', value: 'gpsc', sortable: true, align: 'center', width: "1%"},
			{text: 'ดูข้อมูล', value: 'showData', sortable: true, align: 'center', width: "1%"},
			{text: 'สั่งพิมพ์เพื่อจัดหา', value: 'printBuyPDF', sortable: true, align: 'center', width: "1%"},
			{text: 'สั่งพิมพ์เพื่อดู', value: 'printViewPDF', sortable: true, align: 'center', width: "1%"},
		  ]
		}),
		computed: {
    		// Map Vuex state.
		  ...mapState({
			medSearch: state => {
				return state.Med.medSearch
			},
			meds: state => {
				return state.Med.meds
			},
			pagination: state => {
				return state.Med.pagination
			},
			medGroups: state => {
				return state.MedGroup.medGroups
			},
			medSubGroups: state => {
				return state.MedGroup.medSubGroups
			},
			user: state => {
				return state.Auth.user;
			},

		  })
		},
	  // mounted() {
		//   console.log(this.medGroups)
	  // },
	   created () {
			this.getAllMedGroups();
			this.showTable = true;

			this.searchMeds({
				user_id: this.user.id,
				paginate: this.pagination.current_page,
			});
			this.clear();
	  	},
    	methods: {
		  ...mapActions('Med', [
			'searchMeds'
		  ]),
		  ...mapActions('MedGroup', [
			  'getMedGroups',
			  'getMedSubGroups',
			  'getAllMedGroups'
		  ]),
			search() {
				if(!this.medSearch.name_th &&
						!this.medSearch.name_en &&
						!this.medSearch.main_group &&
						!this.medSearch.sub_group &&
						!this.medSearch.spec_no &&
						!this.medSearch.year) {
					alert('กรุณากรอกคำค้นหา...')
				} else {
					this.$store.dispatch("Med/clearSearch");
					// console.log(this.user)
					let data = {
						user_id: this.user.id,
						paginate: this.pagination.current_page,
					}
					// console.log(data)
					this.$store.dispatch('Med/searchMeds', data)
					// console.log(this.pagination)
					// this.searchMeds(this.user.id,this.pagination.current_page)
				}
		  	},

            getPDF() {
                this.$store.dispatch('Med/getPDF').then(data => {
                    console.log(data)
                })
            },

			onSelectMedGroup (val) {
				  // console.log(val)
				this.medSearch.sub_group = null
				// this.clearMedSubGroup();
				this.getMedSubGroups(val.group_main)
			},

			getOrder(id) {
				this.$store.dispatch('Med/getMed', id).then(data => {
					// console.log(data)
					let data_order = {
						group_num: data.group_num,
						medspec_id: data.id,
						year: data.year,
						print_type: '2',
						user_id: this.user.id,
						status: data.status,
					};
					this.$store.dispatch('Common/saveOrder', data_order).then(data => {
						// console.log('success')
						// Go to PDF
					})
				})
			},
			viewOrder(id) {
				this.$store.dispatch('Med/getMed', id).then(data => {
					let data_order = {
						group_num: data.group_num,
						medspec_id: data.id,
						year: data.year,
						print_type: '1',
						user_id: this.user.id,
						status: data.status,
					};
					this.$store.dispatch('Common/saveViewOrder', data_order).then(data => {
						// Go to PDF
						// console.log('success')
					})
				})
			},
			clear() {
				this.medSearch.name_th = '';
				this.medSearch.name_en = '';
				this.medSearch.main_group = '';
				this.medSearch.sub_group = '';
				this.medSearch.spec_no = '';
				this.medSearch.year = '';
			},

			// Pagination
			getPagination(page) {
				// console.log(page)
				let data = {
					user_id: this.user.id,
					paginate: page,
				}
				this.$store.dispatch('Med/searchMeds', data)

			}

    	}
  }


</script>

<style lang="scss">
	.form-search {
		.v-text-field.v-text-field--solo .v-input__control {
			min-height: 35px !important;
		}

		.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
			border-radius: 20px;
			box-shadow: unset;
		}

		.theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
			color: #527281;
		}

		.theme--light.v-select .v-select__selections {
			color: #527281;
		}

		.theme--light.v-select:hover {
			color: #527281;
		}

		.v-icon.v-icon {
			color: #527281 !important;
			caret-color: #527281 !important;
		}

		.v-text-field.v-text-field--enclosed .v-text-field__details {
			margin-bottom: 0;
		}

		.v-input__slot {
			margin-bottom: 0;
		}

		.v-menu__content.theme--light.menuable__content__active {
			text-align: left !important;
		}
	}

	.table-search {
		.text-left {
			text-align: left;
		}
	}

	th.text-center {
		background: #527281;
		color: white !important;
		font-size: 14px !important;
	}

	th.text-center:not(:last-child) {
		border-right-style: solid;
		border-color: white;
		border-width: 1px;
	}

	.v-data-table td, .v-data-table th {
		padding: 0 4px !important;
	}

	.multiselect {
		margin-bottom: 14px;
		.multiselect__tags {
			height: 32px;
			border-radius: 20px;
			background-color: #E5E5E5;
			color: #84A2A8;
			.multiselect__input, .multiselect__single {
				background-color: #E5E5E5;
			}
		}
		.multiselect__content {
			padding-left: 0;
		}
	}
</style>
